import { Injectable } from '@angular/core';

/**
 * Controls the toasts that appears on the root of the app.
 */
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private _isOpen: boolean = false;
  private _message: string = '';
  private _color: string = '';

  constructor() {}

  get isOpen() {
    return this._isOpen;
  }

  get message() {
    return this._message;
  }

  get color() {
    return this._color;
  }

  /**
   * Opens a toast with success layout
   * @param message A message to be displayed, or the path
   * from translate message to be displayed
   * @param translateParameters Translate parameters to be passed
   * to translate service.
   */
  openSuccessToast(message: string) {
    this._message = message;
    this._color = 'success';
    this._isOpen = true;
  }

  /**
   * Opens a toast with error layout
   * @param message A message to be displayed, or the path
   * from translate message to be displayed
   * @param translateParameters Translate parameters to be passed
   * to translate service.
   */
  openErrorToast(message: string) {
    this._message = message;
    this._color = 'danger';
    this._isOpen = true;
  }

  onDismissToast() {
    this._isOpen = false;
  }
}

